/**
 * UI theme Redux slice.
 *
 * Persists the active colour theme (`"light"` | `"dark"`) in both Redux
 * state and `localStorage`.  On startup `App.tsx` reads the persisted value
 * and applies the CSS class before the first paint to prevent FOUC.
 */
import { createSlice } from "@reduxjs/toolkit";
import { getColorTheme, setColorTheme } from "@service/local-storage-handler";

/** Shape of the theme state tree. */
export interface ThemeState {
  theme: "light" | "dark";
}

const initialThemeState: ThemeState = {
  theme: (getColorTheme() as "light" | "dark") || "dark",
};

export const themeSlice = createSlice({
  name: "theme",
  initialState: initialThemeState,
  reducers: {
    themeReducer: (state, action) => {
      const newTheme = action.payload.theme;
      if (newTheme === "light" || newTheme === "dark") {
        state.theme = newTheme;
        setColorTheme(newTheme);
      }
    },
  },
});

export const { themeReducer } = themeSlice.actions;
export default themeSlice.reducer;
